import FooterNavbar from "../../../footernavbar/FooterNavbar";
import CareerNavbar from "./CareerNavbar";

const WorkWithUs = () => {
  return (
    <>
      <div className=" display-max">
        <FooterNavbar />
        <CareerNavbar />
        <div className="mt-3 py-3">
          <div className="row">
            <div className="container">
              <div className="col-lg-12 justify-content-center text-center ">
                <span className="badge rounded-pill badge-warning text-white text-capitalize mb-2">
                  Careers
                </span>
                <h1 className=" text-black source-serif-4 text-normal mt-2">
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  A career is not just about earning a living; <br />
                  it's about making a meaningful difference.{" "}
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                </h1>
              </div>
            </div>
          </div>
          <div className="w-60 h-50 mx-auto mt-4">
            <div className="d-block blur-shadow-image">
              <img
                src="../../assets/img/footer/career-1.jpg"
                alt="img-blur-shadow-blog-2"
                className="img-full "
                loading="lazy"
              />
            </div>
          </div>
        </div>
        <div className="row w-70 d-flex justify-content-center mx-auto pt-4">
          <section className="py-0">
            <div className="container">
              <div className="row align-items-center">
                <div className="container col-lg-12  col-md-6 position-relative mb-sm-0 mb-3">
                  <h1 className="mb-3 text-black  fw-bold">Careers</h1>
                  <p className="mb-3 fs-4 container text-black">
                    At Sworld solutions private limited, we are on a mission to
                    revolutionize the ecommerce industry with innovative
                    solutions and exceptional customer experiences. As an
                    emerging startup, we are looking for passionate, driven, and
                    creative individuals to join our dynamic team. If you are
                    looking to make an impact, grow your career, and be part of
                    something exciting, Sworld is the place for you.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section className="py-5">
            <div className="container">
              <div className="row">
                <h1 className=" text-black source-serif-4 justify-content-center text-center mb-6 text-normal mt-2">
                  <sup>
                  <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  Why Join Us?
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                </h1>
                <div className="col-lg-6 col-10 d-flex justify-content-center flex-column  text-lg-start text-center">
                  <div className="mb-3">
                    <h2 className="mb-3 text-black fw-bold">
                      1. Innovative Culture
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      We thrive on innovation and creativity. At Sworld , you
                      will have the opportunity to work on cutting-edge projects
                      and bring your ideas to life. We encourage experimentation
                      and embrace new approaches to solve complex challenges.
                    </p>
                  </div>
                  <div>
                    <h2 className="mb-3 text-black fw-bold ">
                      2. Growth Opportunities
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      As a fast-growing startup, we offer unparalleled
                      opportunities for career advancement. You will have the
                      chance to take on new responsibilities, develop your
                      skills, and grow with the company. We believe in promoting
                      from within and supporting our employees' career
                      aspirations.
                    </p>
                  </div>
                  <div>
                    <h2 className="mb-3 text-black fw-bold ">
                      3. Collaborative Environment
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      Collaboration is at the heart of our success. You will
                      work alongside talented and passionate colleagues who
                      share your dedication to excellence. Our open and
                      inclusive culture fosters teamwork, respect, and mutual
                      support.
                    </p>
                  </div>
                </div>
                <div className="col-lg-1"></div>
                <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                  <img
                    className="w-100 border-radius-lg "
                    src="../../assets/img/footer/career-2.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </section>
          <section className="py-5">
            <div className="container">
              <div className="row">
                <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                  <img
                    className="w-100 border-radius-lg "
                    src="../../assets/img/footer/career-3.jpg"
                    alt=""
                  />
                </div>
                <div className="col-lg-1"></div>
                <div className="col-lg-6 col-10 d-flex justify-content-center flex-column  text-lg-start text-center">
                  <div className="mb-3">
                    <h2 className="mb-3 text-black fw-bold">
                      4. Impactful Work
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      At Sworld, your work will have a direct impact on our
                      success and our customers' satisfaction. You will be
                      empowered to make decisions, take ownership of your
                      projects, and contribute to the company's growth and
                      innovation.
                    </p>
                  </div>
                  <div>
                    <h2 className="mb-3 text-black fw-bold ">
                      5. Commitment to Diversity and Inclusion
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      We value diversity and are committed to creating an
                      inclusive environment where everyone feels welcome and
                      respected. We believe that diverse perspectives drive
                      innovation and better decision-making.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="py-5">
            <div className="container">
              <div className="row">
                <h1 className=" text-black source-serif-4 justify-content-center text-center mb-6 text-normal mt-2">
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  Career Development
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                </h1>
                <div className="col-lg-6 col-10 d-flex justify-content-center flex-column  text-lg-start text-center">
                  <div className="mb-3">
                    <h2 className="mb-3 text-black fw-bold">
                      1. Professional Growth
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      We are dedicated to your professional development. We
                      offer various training programs, workshops, and mentorship
                      opportunities to help you enhance your skills and advance
                      your career. Whether you are looking to deepen your
                      expertise or explore new areas, we provide the resources
                      and support you need to succeed.
                    </p>
                  </div>
                  <div>
                    <h2 className="mb-3 text-black fw-bold ">
                      2. Learning and Development
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      Continuous learning is essential in the fast-paced world
                      of ecommerce. We provide access to online learning
                      platforms, industry conferences, and in-house training
                      sessions to keep you up-to- date with the latest trends
                      and technologies.
                    </p>
                  </div>
                  <div>
                    <h2 className="mb-3 text-black fw-bold ">
                      3. Leadership Opportunities
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      As we grow, we are always on the lookout for future
                      leaders. We offer leadership development programs and
                      opportunities to take on management roles. If you have the
                      ambition and potential, we will help you achieve your
                      leadership goals.
                    </p>
                  </div>
                </div>
                <div className="col-lg-1"></div>
                <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                  <img
                    className="w-100 border-radius-lg "
                    src="../../assets/img/footer/career-4.jpeg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </section>
          <section className="py-5">
            <div className="container">
              <div className="row">
                <h1 className=" text-black source-serif-4 justify-content-center text-center mb-6 text-normal mt-2">
                  <sup>
                  <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  Employee Benefits
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                </h1>
                <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                  <img
                    className="w-100 border-radius-lg "
                    src="../../assets/img/footer/career-5.jpg"
                    alt=""
                  />
                </div>
                <div className="col-lg-1"></div>
                <div className="col-lg-6 col-10 d-flex justify-content-center flex-column  text-lg-start text-center">
                  <div className="mb-2">
                    <h4 className="mb-2 text-black fw-bold">
                      1. Health and Wellness
                    </h4>
                    <p className="mb-2 fs-5 container text-black">
                      We care about your health and well-being. Our
                      comprehensive health insurance plans cover medical,
                      dental, and vision care. We also offer wellness programs,
                      mental health support, and gym memberships to promote a
                      healthy lifestyle.
                    </p>
                  </div>
                  <div>
                    <h4 className="mb-2 text-black fw-bold ">
                      2. Work-Life Balance
                    </h4>
                    <p className="mb-2 fs-5 container text-black">
                      We understand the importance of work-life balance. Our
                      flexible work arrangements, including remote work options
                      and flexible hours, help you manage your personal and
                      professional commitments effectively.
                    </p>
                  </div>
                  <div>
                    <h4 className="mb-2 text-black fw-bold ">
                      3. Competitive Compensation
                    </h4>
                    <p className="mb-2 fs-5 container text-black">
                      We offer competitive salaries and performance-based
                      bonuses to reward your hard work and dedication. Our
                      compensation packages are designed to attract and retain
                      top talent.
                    </p>
                  </div>
                  <div>
                    <h4 className="mb-2 text-black fw-bold ">
                      4. Parental Leave and Family Support
                    </h4>
                    <p className="mb-2 fs-5 container text-black">
                      We provide generous parental leave policies and
                      family-friendly benefits to support you during important
                      life events. Our policies are designed to help you balance
                      your work and family responsibilities.
                    </p>
                  </div>
                  <div>
                    <h4 className="mb-2 text-black fw-bold ">
                      5. Employee Perks
                    </h4>
                    <p className="mb-2 fs-5 container text-black">
                      Enjoy discounts on our products and services, access to
                      exclusive company events, and opportunities to participate
                      in community engagement and volunteer activities.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <section className="py-6">
          <div className="row">
            <div className="container">
              <div className="col-lg-12 justify-content-center text-center ">
                <h1 className=" text-black source-serif-4 text-normal mt-2">
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  Join Our Team
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                </h1>
                <h4 className=" text-black source-serif-4 text-normal mt-2">
                  <sup>
                  <i
                      className="ri-double-quotes-l text-dark text-lg"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  At Sworld solutions private limited, we are always looking for
                  talented individuals who are passionate about making a
                  difference. <br /> If you are ready to take the next step in
                  your career and be part of a dynamic and innovative team,{" "}
                  <br /> we want to hear from you. Explore our current job
                  openings and apply today!
                  <sup>
                  <i
                      className="ri-double-quotes-r text-dark text-lg"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                </h4>
              </div>
            </div>
          </div>
          <div className="w-60 h-50 mx-auto mt-4">
            <div className="d-block blur-shadow-image">
              <img
                src="../../assets/img/footer/team.jpg"
                alt="img-blur-shadow-blog-2"
                className="img-full "
                loading="lazy"
              />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default WorkWithUs;
